import { MediaState, MediaFile, MediaFileId } from './domain/media-file.types';

export const updateFile = (
  state: MediaState,
  id: MediaFileId,
  updater: (file: MediaFile) => MediaFile
): MediaState => {
  return state.map((file) => (file.id === id ? updater(file) : file));
};

export const removeFile = (state: MediaState, id: MediaFileId): MediaState => {
  return state.filter((file) => file.id !== id);
};

export const loadVideoMetadata = (
  url: string
): Promise<
  Required<Pick<Extract<MediaFile, { type: 'video' }>, 'duration' | 'poster'>>
> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.src = url;
    video.crossOrigin = 'anonymous';

    video.onloadedmetadata = () => {
      const duration = video.duration;

      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext('2d');

      if (ctx) {
        video.currentTime = duration / 2;

        video.onseeked = () => {
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          const poster = canvas.toDataURL('image/jpeg');
          resolve({ duration, poster });
        };
      } else {
        resolve({ duration, poster: '' });
      }
    };

    video.onerror = () => reject(new Error('Failed to load video metadata'));
  });
};
